/**
 * Returns an empty string.
 *
 * @returns {string} An empty string.
 * @example
 * stubString() // Returns ''
 */
export function stubString(): '' {
  return '';
}
